import List from "./list";
import Operation from "./operation";
import toString from "lodash/toString";
import isEqual from "lodash/isEqual";
import isEmpty from "lodash/isEmpty";
import uniqBy from "lodash/uniqBy";
import cloneDeep from "lodash/cloneDeep";
import middleware from "../../middleware";

class Main extends React.Component {
  static Operation = Operation;

  constructor(props) {
    super(props);
    const { dataUrl } = this.props;
    this.state = {
      leftData: props.data,
      rightData: [],
      leftCheckedKeys: [],
      rightCheckedKeys: []
    };
    if (!isEmpty(props.selectedKeys) && !isEmpty(props.data)) {
      let rightData = [];
      props.selectedKeys.forEach(key => {
        let filterDatas = props.data.filter(
          i => toString(i.id) === toString(key)
        );
        if (filterDatas.length > 0) {
          rightData.push(filterDatas[0]);
        }
      });
      this.state.rightData = rightData;
    }
    const funcs = [
      "onLeftCheck",
      "onLeftDoubleClick",
      "onRightCheck",
      "onRightDoubleClick",
      "onRightDrag"
    ];
    funcs.forEach(f => (this[f] = this[f].bind(this)));
  }
  componentDidMount() {}
  componentWillReceiveProps(nextProps) {
    let { leftData } = this.state;
    let rightData = [];
    let selectedKeys = this.props.selectedKeys || [];
    if ("data" in nextProps) {
      leftData = nextProps.data || [];
    }
    if (
      "selectedKeys" in nextProps &&
      !isEqual(this.props.selectedKeys, nextProps.selectedKeys)
    ) {
      selectedKeys = nextProps.selectedKeys || [];
    }
    selectedKeys.forEach(key => {
      let filterDatas = leftData.filter(i => toString(i.id) === toString(key));
      if (filterDatas.length > 0) {
        rightData.push(filterDatas[0]);
      }
    });
    this.setState({ leftData, rightData });
  }
  moveTo = direction => {
    let { leftCheckedKeys, rightCheckedKeys, rightData, leftData } = this.state;
    if (direction === "right") {
      let checked = [];
      leftData.forEach(item => {
        if (leftCheckedKeys.indexOf(toString(item.id)) > -1) {
          checked.push(item);
        }
      });
      rightData = rightData.concat(checked);
      if (this.props.moveToRightCB) {
        rightData = this.props.moveToRightCB(rightData);
      }
      this.setState({ leftCheckedKeys: [], rightCheckedKeys: [], rightData });
      this.onChange(rightData);
    }
    if (direction === "left") {
      if (
        this.props.moveToLeftBeforeCB &&
        !this.props.moveToLeftBeforeCB(rightCheckedKeys)
      ) {
        this.setState({ rightCheckedKeys: [] });
        return;
      }
      rightData = rightData.filter(item => {
        return rightCheckedKeys.indexOf(toString(item.id)) == -1;
      });
      this.setState({
        leftCheckedKeys: [],
        rightCheckedKeys: [],
        rightData: rightData
      });
      this.onChange(rightData);
      this.props.moveToLeftCB &&
        this.props.moveToLeftCB(rightData, rightCheckedKeys);
    }

    if (direction === "allToLeft") {
      let rgData = [],
        targetkeys = [];
      if (this.props.filterRight) {
        const filterDatas =
          cloneDeep(this.props.filterRight(cloneDeep(rightData))) || [];
        filterDatas.forEach(d => targetkeys.push(toString(d.id)));
        rgData = rightData.filter(item => {
          return targetkeys.indexOf(toString(item.id)) == -1;
        });
        if (
          this.props.moveToLeftBeforeCB &&
          !this.props.moveToLeftBeforeCB(targetkeys)
        )
          return;
      }
      this.setState({
        leftCheckedKeys: [],
        rightCheckedKeys: [],
        rightData: rgData
      });
      this.onChange(rgData);
      this.props.moveToLeftCB && this.props.moveToLeftCB(rgData, targetkeys);
    }

    if (direction === "allToRight") {
      let targetData = cloneDeep(leftData);
      if (this.props.filterLeft) {
        targetData = cloneDeep(this.props.filterLeft(cloneDeep(targetData)));
        targetData = rightData.concat(targetData);
      }
      if (this.props.moveToRightCB) {
        targetData = this.props.moveToRightCB(targetData);
        targetData = rightData.concat(targetData);
      }
      targetData = uniqBy(targetData, "id");
      this.setState({
        leftCheckedKeys: [],
        rightCheckedKeys: [],
        rightData: targetData
      });
      this.onChange(targetData);
    }
  };
  moveToLeft = () => this.moveTo("left");
  moveToRight = () => this.moveTo("right");
  moveAllToLeft = () => this.moveTo("allToLeft");
  moveAllToRight = () => this.moveTo("allToRight");

  leftListAllActive() {
    let bool = true;
    const { rightData, leftData } = this.state;
    bool =
      leftData.filter(item => !rightData.some(i => i.id === item.id)).length >
      0;
    return bool;
  }

  leftListActive() {
    let { rightData, rightCheckedKeys } = this.state;
    if (!isEmpty(rightCheckedKeys)) {
      return (
        rightCheckedKeys.filter(item => rightData.some(i => i.id == item))
          .length > 0
      );
    }
    return false;
  }

  onLeftCheck(keys, e) {
    if (this.props.leftCheckCB) {
      keys = this.props.leftCheckCB(keys, e);
    }
    this.setState({ leftCheckedKeys: keys });
  }
  onLeftDoubleClick(key) {
    if (this.props.leftDoubleClickCB) {
      if (!this.props.leftDoubleClickCB(key)) return;
    }
    let { rightData, leftData } = this.state;
    const data = leftData.filter(item => toString(item.id) === toString(key));
    rightData = rightData.concat(data);
    this.setState({ leftCheckedKeys: [], rightCheckedKeys: [], rightData });
    this.onChange(rightData);
  }
  onRightDoubleClick(key) {
    let { rightData } = this.state;
    if (this.props.moveToLeftBeforeCB && !this.props.moveToLeftBeforeCB(key))
      return;
    rightData = rightData.filter(item => toString(item.id) !== toString(key));
    this.setState({
      leftCheckedKeys: [],
      rightCheckedKeys: [],
      rightData: rightData
    });
    this.onChange(rightData);
    this.props.moveToLeftCB && this.props.moveToLeftCB(rightData, key);
  }
  onRightCheck(keys, e) {
    if (this.props.rightCheckCB) {
      keys = this.props.rightCheckCB(keys, e);
    }
    this.setState({ rightCheckedKeys: keys });
  }
  onRightDrag(data) {
    this.setState({ rightData: data });
    this.onChange(data);
  }
  get() {
    const { rightData } = this.state;
    let ids = [];
    rightData.forEach(item => ids.push(toString(item.id)));
    return ids;
  }
  clear() {
    this.setState({ leftCheckedKeys: [], rightCheckedKeys: [] });
  }
  onChange(datas) {
    let ids = [];
    datas.forEach(item => ids.push(toString(item.id)));
    this.props.onChange && this.props.onChange(ids, datas);
  }

  render() {
    let { leftData, rightData, leftCheckedKeys, rightCheckedKeys } = this.state;
    const { height, renderItem, renderLeft, renderRight, style } = this.props;
    let rightDisplayData = cloneDeep(rightData);
    if (this.props.filterLeft) {
      leftData = cloneDeep(this.props.filterLeft(cloneDeep(leftData)));
    }
    if (this.props.filterRight) {
      rightDisplayData = cloneDeep(this.props.filterRight(rightDisplayData));
    }
    return (
      <div
        className={`wea-transfer ${this.props.className || ""}`}
        style={style}
      >
        <List
          {...this.props}
          renderItem={renderLeft || renderItem}
          header={this.props.leftHeader}
          className="wea-transfer-left-wrapper"
          data={leftData}
          draggable={false}
          checkedCb={this.onLeftCheck}
          onDoubleClick={this.onLeftDoubleClick}
          checkedKeys={leftCheckedKeys}
          filterData={rightData}
          height={height}
        />
        <Operation
          className="wea-transfer-opration"
          rightActive={leftCheckedKeys.length > 0}
          leftActive={this.leftListActive()}
          leftAllActive={this.leftListAllActive()}
          rightAllActive={rightData.length > 0}
          moveToRight={this.moveToRight}
          moveToLeft={this.moveToLeft}
          moveAllToRight={this.moveAllToRight}
          moveAllToLeft={this.moveAllToLeft}
        />
        <List
          {...this.props}
          renderItem={renderRight || renderItem}
          header={this.props.rightHeader}
          className="wea-transfer-right-wrapper"
          data={rightDisplayData}
          draggable={true}
          onDrag={this.onRightDrag}
          checkedCb={this.onRightCheck}
          onDoubleClick={this.onRightDoubleClick}
          checkedKeys={rightCheckedKeys}
          height={height}
        />
      </div>
    );
  }
}

Main.list = List;

const Com = middleware(Main, "WeaTransfer");
export default Com;



// WEBPACK FOOTER //
// ./ecology9/wea-transfer/index.js